import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid
} from "recharts";

const CHART_COLORS = ["#4A7AB5", "#F5A623", "#8CAED6", "#F9C77A", "#5BA88E"];

function CustomYTick({ x, y, payload }) {
    const name = payload?.value || "";
    const display = name.length > 22 ? name.substring(0, 21) + "\u2026" : name;
    return (
        <g transform={`translate(${x},${y})`}>
            <title>{name}</title>
            <text x={-4} y={0} dy={4} textAnchor="end" fill="#475569" fontSize={11} fontFamily="Outfit, sans-serif">
                {display}
            </text>
        </g>
    );
}

function CustomBarLabel({ x, y, width, height, value }) {
    if (width < 20) return null;
    return (
        <text x={x + width - 6} y={y + height / 2} dy={4} textAnchor="end"
            fill="#fff" fontSize={11} fontWeight={600} fontFamily="Outfit, sans-serif">
            {value}
        </text>
    );
}

export function ArchetypeChart({ archetypeData }) {
    if (archetypeData.length === 0) return null;

    return (
        <Card className="border-border bg-card overflow-hidden">
            <CardHeader className="pb-1">
                <div className="flex items-center justify-between">
                    <CardTitle className="text-base font-semibold" style={{ fontFamily: "Outfit" }}>
                        Archetype Distribution
                    </CardTitle>
                    <span className="text-xs text-muted-foreground">
                        {archetypeData.reduce((s, d) => s + d.value, 0)} completed assessments
                    </span>
                </div>
            </CardHeader>
            <CardContent className="px-2 sm:px-4 pb-4">
                <div className="w-full overflow-hidden" style={{ height: Math.max(180, archetypeData.length * 44 + 24) }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={archetypeData}
                            layout="vertical"
                            margin={{ top: 4, right: 12, bottom: 4, left: 4 }}
                            barCategoryGap="20%"
                        >
                            <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="#E2E8F0" opacity={0.5} />
                            <XAxis type="number" stroke="#94A3B8" fontSize={10} tickLine={false} axisLine={false} allowDecimals={false} />
                            <YAxis type="category" dataKey="name" width={140} stroke="transparent" tickLine={false} axisLine={false} tick={<CustomYTick />} />
                            <Tooltip
                                cursor={{ fill: "rgba(74,122,181,0.06)", radius: 4 }}
                                contentStyle={{
                                    backgroundColor: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "8px",
                                    color: "#1E293B", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", padding: "8px 12px",
                                    fontFamily: "Outfit, sans-serif", fontSize: "12px"
                                }}
                                formatter={(val, name, props) => [`${val} users`, props.payload.name]}
                                labelFormatter={() => ""}
                            />
                            <Bar dataKey="value" radius={[0, 6, 6, 0]} maxBarSize={28} label={<CustomBarLabel />}>
                                {archetypeData.map((entry, i) => (
                                    <Cell key={`cell-${entry.name}`} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    );
}
